
import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// DELETE subscription

const deleteSubscriptionPending = (state: AppState) => state.deleteSubscription.pending;
const deleteSubscription = (state: AppState) => state.deleteSubscription.success;
const deleteSubscriptionError = (state: AppState) => state.deleteSubscription.error;

export const deleteSubscriptionSelector = createSelector(deleteSubscription, (source) => source);
export const deleteSubscriptionPendingSelector = createSelector(deleteSubscriptionPending,(pending) => pending);
export const deleteSubscriptionErrorSelector = createSelector(deleteSubscriptionError, (error) => error);

// POST subscription

const postSubscriptionPending = (state: AppState) => state.postSubscription.pending;
const postSubscription = (state: AppState) => state.postSubscription.subscription;
const postSubscriptionError = (state: AppState) => state.postSubscription.error;

export const postSubscriptionPendingSelector = createSelector(postSubscriptionPending,(pending) => pending);
export const postSubscriptionSelector = createSelector(postSubscription, (subscription) => subscription);
export const postSubscriptionErrorSelector = createSelector(postSubscriptionError, (error) => error);

// POST extractor subscription

const postExtractorSubscriptionPending = (state: AppState) => state.postExtractorSubscription.pending;
const postExtractorSubscription = (state: AppState) => state.postExtractorSubscription.subscription;
const postExtractorSubscriptionError = (state: AppState) => state.postExtractorSubscription.error;

export const postExtractorSubscriptionPendingSelector = createSelector(postExtractorSubscriptionPending,(pending) => pending);
export const postExtractorSubscriptionSelector = createSelector(postExtractorSubscription, (subscription) => subscription);
export const postExtractorSubscriptionErrorSelector = createSelector(postExtractorSubscriptionError, (error) => error);

// LIST subscription

const fetchSubscriptionPending = (state: AppState) => state.fetchSubscription.pending;
const fetchSubscription = (state: AppState) => state.fetchSubscription.subscription;
const fetchSubscriptionError = (state: AppState) => state.fetchSubscription.error;

export const fetchSubscriptionPendingSelector = createSelector(fetchSubscriptionPending,(pending) => pending);
export const fetchSubscriptionSelector = createSelector(fetchSubscription, (subscription) => subscription);
export const fetchSubscriptionErrorSelector = createSelector(fetchSubscriptionError, (error) => error);